import { EdiConnectionType } from '../../enum/edi';
import { BaseDto } from '../base.dto';

export class EdiConnectionTypeDto extends BaseDto {
  type:  EdiConnectionType;
  name: string;
}
